import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Form, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb';
import industriesData from './data/industries';
import Select from 'react-select';
import studyDirectionsData from './data/studyDirections.js';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MappingIndustries = () => {
    const [industries, setIndustries] = useState([
        { industry: '', subIndustry: [] },
    ]);

    const navigate = useNavigate();

    const [studyMappings, setStudyMappings] = useState([
        { studyField: '', studyDirection: '' }
    ]);

    const handleIndustryChange = (index, key, value) => {
        const updated = [...industries];
        updated[index][key] = value;
        setIndustries(updated);
    };

    const onAddStudyDirection = () => {
        setStudyMappings([...studyMappings, { studyField: '', studyDirection: '' }]);
    };

    const handleStudyMappingChange = (index, key, value) => {
        const updated = [...studyMappings];
        updated[index][key] = value;
    
        // Reset direction if field changes
        if (key === 'studyField') {
            updated[index]['studyDirection'] = '';
        }
    
        setStudyMappings(updated);
    };

    const onRemoveStudyDirection = () => {
        if (studyMappings.length > 1) {
            setStudyMappings(studyMappings.slice(0, -1));
        }
    };

    const handleSave = async () => {
        const selectedIndustry = industries[0]?.industry;
        const selectedSubIndustry = industries[0]?.subIndustry;
    
        if (!selectedIndustry || !selectedSubIndustry || studyMappings.length === 0) {
            alert("Please complete all fields before saving.");
            return;
        }
    
        const payload = {
            industry: selectedIndustry,
            subIndustry: selectedSubIndustry,
            studyMappings
        };
    
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/api/mappings`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );
            alert('Mapping saved successfully.');
            navigate('/mapping-overview');
        } catch (error) {
            console.error('Error saving mapping:', error);
            alert('Error saving mapping. Check console for details.');
        }
    };
    

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Mapping 1 - Industry mapping</h1>
                                <Row className="mb-4">
                                    <Col>
                                        {industries.map((industry, index) => {
                                            const selectedIndustry = industriesData.find(ind => ind.code === industry.industry);

                                            return (
                                                <Card className="mb-3" key={index}>
                                                    <Card.Body>
                                                        <Row className="mb-4">
                                                            <Col md={12}>
                                                                <label>Industry *</label>
                                                                <Select
                                                                    options={industriesData.map(ind => ({
                                                                        value: ind.code,
                                                                        label: ind.name,
                                                                    }))}
                                                                    value={industry.industry ? { value: industry.industry, label: industriesData.find(ind => ind.code === industry.industry)?.name } : null}
                                                                    onChange={(selected) =>
                                                                        handleIndustryChange(index, 'industry', selected?.value || '')
                                                                    }
                                                                    isClearable
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-3">
                                                            <Col md={12}>
                                                                <label>Sub Industry / Sub Sub Industry *</label>
                                                                <Select
                                                                    options={
                                                                        selectedIndustry
                                                                            ? selectedIndustry.subIndustries.flatMap(sub => [
                                                                                { value: sub.code, label: sub.name },
                                                                                ...(sub.subSubIndustries || []).map(subSub => ({
                                                                                    value: subSub.code,
                                                                                    label: `- ${subSub.name}`,
                                                                                })),
                                                                            ])
                                                                            : []
                                                                    }
                                                                    value={
                                                                        selectedIndustry?.subIndustries
                                                                            .flatMap(sub => [
                                                                                { value: sub.code, label: sub.name },
                                                                                ...(sub.subSubIndustries || []).map(subSub => ({
                                                                                    value: subSub.code,
                                                                                    label: `- ${subSub.name}`,
                                                                                })),
                                                                            ])
                                                                            .find(option => option.value === industry.subIndustry) || null
                                                                    }
                                                                    onChange={(selected) =>
                                                                        handleIndustryChange(index, 'subIndustry', selected?.value || '')
                                                                    }
                                                                    isClearable
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>
                                                </Card>
                                            );
                                        })}
                                    </Col>
                                    <Col>
                                        <Card>
                                            <Card.Body>
                                                {studyMappings.map((mapping, index) => (
                                                    <Row className="mb-4" key={index}>
                                                        <Col md={6}>
                                                            <label>Study Field *</label>
                                                            <Form.Control
                                                                as="select"
                                                                name="studyField"
                                                                value={mapping.studyField}
                                                                onChange={(e) =>
                                                                    handleStudyMappingChange(index, 'studyField', e.target.value)
                                                                }
                                                            >
                                                                <option value="">Please Select</option>
                                                                {studyDirectionsData.map((field, idx) => (
                                                                    <option key={idx} value={field.name}>
                                                                        {field.name}
                                                                    </option>
                                                                ))}
                                                            </Form.Control>
                                                        </Col>
                                                        <Col md={6}>
                                                            <label>Study Direction *</label>
                                                            <Form.Control
                                                                as="select"
                                                                name="studyDirection"
                                                                value={mapping.studyDirection}
                                                                onChange={(e) =>
                                                                    handleStudyMappingChange(index, 'studyDirection', e.target.value)
                                                                }
                                                                disabled={!mapping.studyField}
                                                            >
                                                                <option value="">Please Select</option>
                                                                {mapping.studyField &&
                                                                    studyDirectionsData
                                                                        .find(field => field.name === mapping.studyField)
                                                                        ?.subDirections.map((direction, idx) => (
                                                                            <option key={idx} value={direction}>
                                                                                {direction}
                                                                            </option>
                                                                        ))
                                                                 }
                                                            </Form.Control>
                                                        </Col>
                                                    </Row> 
                                                ))}
                                                <Row>
                                                    <Col className="d-flex justify-content-end gap-2">
                                                        <Button variant="danger" onClick={onRemoveStudyDirection}>
                                                            Remove
                                                        </Button>
                                                        <Button variant="primary" onClick={onAddStudyDirection}>
                                                            Add New
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button variant="secondary" onClick={() => navigate('/mapping-overview')}>
                            Back
                        </Button>
                        <Button variant="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MappingIndustries;
